import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';

// Context
import { GameProvider, useGame } from './contexts/GameContext';

// Components
import GameScreen from './components/game/GameScreen';
import CreateLobby from './components/lobby/CreateLobby';
import JoinLobby from './components/lobby/JoinLobby';
import LobbyScreen from './components/lobby/LobbyScreen';
import FirebaseDebug from './debug/FirebaseDebug';

// Main App container
function AppContainer() {
  const { playerId, lobbyCode, lobby, lobbyError } = useGame();
  
  // Redirect based on game state
  const getRedirect = () => {
    // No player ID means user needs to join or create a lobby
    if (!playerId) {
      return <Navigate to="/" replace />;
    }
    
    // Player has ID but no lobby - send to home screen (join functionality is on home)
    if (!lobbyCode || lobbyError) {
      return <Navigate to="/" replace />;
    }
    
    // Player has lobby and game has started - go to game screen
    if (lobby && lobby.gameStarted) {
      return <Navigate to={`/game/${lobbyCode}`} replace />;
    }
    
    // Player has lobby but game hasn't started - go to lobby
    if (lobby) {
      return <Navigate to={`/lobby/${lobbyCode}`} replace />;
    }
    
    // Default fallback
    return <Navigate to="/" replace />;
  };
  
  return (
    <div className="app-container">
      <Routes>
        {/* Home page with options to create or join */}
        <Route path="/" element={(
          <div className="home-screen">
            <img src="/logo.png" alt="Feast of Gods" className="home-logo" />
            <h1>Feast of Gods</h1>
            <p className="home-subtitle">Mitolojik Kurt Adam Oyunu</p>
            <div className="home-options">
              <CreateLobby />
              <div className="home-separator">or</div>
              <JoinLobby />
            </div>
          </div>
        )} />
        
        {/* Join lobby page - Removed as per user request */}
        
        {/* Lobby waiting room */}
        <Route path="/lobby/:lobbyCode" element={
          lobby ? <LobbyScreen /> : getRedirect()
        } />
        
        {/* Game screen */}
        <Route path="/game/:lobbyCode" element={
          (lobby && lobby.gameStarted) ? <GameScreen /> : getRedirect()
        } />
        
        {/* Debug route */}
        <Route path="/debug" element={<FirebaseDebug />} />
        
        {/* Catch-all redirect */}
        <Route path="*" element={getRedirect()} />
      </Routes>
    </div>
  );
}

// Root App with providers
function App() {
  return (
    <Router>
      <GameProvider>
        <AppContainer />
      </GameProvider>
    </Router>
  );
}

export default App;
